import type { SocialPostStatus } from '@borradh-workspace/api-client/types';

/**
 * Mirrors the API's immutable social-post states. Keep every client-side edit
 * surface behind this policy so a lifecycle rule cannot drift between views.
 */
export function isSocialPostEditable(
  status: SocialPostStatus | null | undefined
): boolean {
  return status !== 'publishing' && status !== 'published';
}

const STALE_POST_REASON_PREFIX = 'Missed its scheduled time.';
const NOT_CONNECTED_REASON_PREFIX = 'Connect Facebook or Instagram';
const GENERIC_FAILURE_REASON =
  'Publishing failed. Pick a new time to try again.';

/**
 * Customer-facing reason for a failed post. The stale-sweep and
 * missing-connection reasons are written for customers and shown verbatim;
 * every other stored errorMessage is raw developer/platform text and is mapped
 * to one short plain line instead.
 */
export function socialPostFailureReason(
  status: SocialPostStatus | null | undefined,
  errorMessage: string | null | undefined
): string | null {
  if (status !== 'failed') return null;
  if (
    errorMessage?.startsWith(STALE_POST_REASON_PREFIX) ||
    errorMessage?.startsWith(NOT_CONNECTED_REASON_PREFIX)
  ) {
    return errorMessage;
  }
  return GENERIC_FAILURE_REASON;
}
